export default {
  title: "Finanz",
  assignBookingAccount: "Konten zuweisen",
  bookingAccount: 'Konto',
  bookingAccounts: 'Konten',
  elbaFibu: {
    invoice: {
      title: "Rechnung",
      submit: "Elba RE Einzug"
    },
    credit: {
      title: "Gutschrift",
      submit: "Elba GS Überweisung"
    }
  },
  booking: {
    expense: "Aufwand",
    "revenue": "Erlös",
    expenseAccountOne: 'Aufwandskonto',
    expenseAccountTwo: 'Aufwandskonto 2',
    thirdPartyCountry: 'Drittland',
    eu: 'EU',
    costType: 'Kostenart',
    lmCostType: 'Kostenstelle Lohnmast',
    costUnit: 'Kostenstelle',
    revenueAccountOne: 'Erlöskonto',
    revenueAccountTwo: 'Erlöskonto 2',
    revenueThirdPartyCountry: 'Drittland',
    revenueEu: 'EU',
    revenueCostType: 'Kostenart',
    revenueLmCostType: 'Kostenstelle Lohnmast',
    revenueCostUnit: 'Kostenstelle'
  },
  name: 'Fibu Name',
  shortName: 'Fibu Name kurz',
  debitNumber: 'Debit Nr.',
  creditNumber: 'Kredit Nr.',
  uid: 'UID',
  lumpSum: 'Pauschaliert',
  groups: {
    info: 'Info',
    bank: 'Bank- Konto'
  },
  bank: {
    iban: 'IBAN',
    name: 'Bank'
  },
  creditDebit: 'Kreditor & Debitor',
  creditor: 'Kreditor',
  debitor: 'Debitor',
  dbAccount: 'DB. Konto',
  counterAccount: 'Gegen- Konto',
  secondCounterAccount: '2. Gegen- Konto',
  locks: "Einzug & Sperren",
  lockTypes: {
    billingLockPork: 'Verrechnungssperre Mast',
    collectionLockPiglet: 'Einzug Ferkel',
    collectionLockPork: 'Einzug Mast',
    paymentLockPiglet: 'Zahlungssperre Ferkel',
    paymentLockPork: 'Zahlungssperre Mast'
  },
  paymentConditions: 'Zahlungskonditionen',
  notification: {
    updateBookingAccount: {
      type: 'success',
      message: 'Konten erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    }
  }
}
